import SadWoman from './SadWoman.svg';
import IcchyaLogo from './IcchyaLogo.svg';
import Checklist from './Checklist.svg';
import Discussion from './Discussion.svg';
import Stories from './Stories.svg';
import WomanHeart from './WomanHeart.svg';
import Help from './Help.svg';
import Gyankosh from './Gyankosh.svg';
import Kindness from './Kindness.svg';
import SuicideCover from './SuicideCover.svg';
import WorriedMan from './WorriedMan.svg';

export {
  SadWoman,
  IcchyaLogo,
  Checklist,
  Discussion,
  Stories,
  WomanHeart,
  Help,
  Gyankosh,
  Kindness,
  SuicideCover,
  WorriedMan,
};
